import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const fiatVolumeApi = createApi({
  reducerPath: 'fiatVolumeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('X-Token', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getFiatVolumeStats: builder.query({
      query: ({ fiatAsset, start, end }) => {
        let url = '/admin/fiat/volume-stats';
        const params = [];
        if (fiatAsset) params.push(`fiat_asset=${fiatAsset}`);
        if (start) params.push(`start=${formatDate(start)}`);
        if (end) params.push(`end=${formatDate(end)}`);
        if (params.length) url += `?${params.join('&')}`;
        return url;
      },
    }),
  }),
});

export const { useGetFiatVolumeStatsQuery } = fiatVolumeApi;
